import React from "react";
import { useParams } from "react-router-dom";
import SEO from "../common/SEO";
import HeaderOne from "../common/header/HeaderOne";
import FooterTwo from "../common/footer/FooterTwo";
import "../common/styles/panel.css";
import { useTranslation } from "react-i18next";

const CaseStudyDetail = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  
  // 案例研究数据
  const caseStudies = {
    "adelaide-tech": {
      title: t("case_study_detail.adelaide_tech.title"),
      year: t("case_study_detail.adelaide_tech.year"),
      location: t("case_study_detail.adelaide_tech.location"),
      clientType: t("case_study_detail.adelaide_tech.client_type"),
      challenge: t("case_study_detail.adelaide_tech.challenge"),
      solution: t("case_study_detail.adelaide_tech.solution"),
      image: "/images/about/ashely.png",
      outcomes: [
        t("case_study_detail.adelaide_tech.outcomes.0"),
        t("case_study_detail.adelaide_tech.outcomes.1"),
        t("case_study_detail.adelaide_tech.outcomes.2")
      ]
    },
    "lorenzo-journey": {
      title: t("case_study_detail.lorenzo.title"),
      year: t("case_study_detail.lorenzo.year"),
      location: t("case_study_detail.lorenzo.location"),
      clientType: t("case_study_detail.lorenzo.client_type"),
      challenge: t("case_study_detail.lorenzo.challenge"),
      solution: t("case_study_detail.lorenzo.solution"),
      image: "/images/about/lorenzo1.png",
      solutionItems: [
        t("case_study_detail.lorenzo.solution_items.0"),
        t("case_study_detail.lorenzo.solution_items.1"),
        t("case_study_detail.lorenzo.solution_items.2")
      ],
      outcomes: [
        t("case_study_detail.lorenzo.outcomes.0"),
        t("case_study_detail.lorenzo.outcomes.1"),
        t("case_study_detail.lorenzo.outcomes.2")
      ],
      testimonial: {
        quote: t("case_study_detail.lorenzo.testimonial.quote"),
        author: t("case_study_detail.lorenzo.testimonial.author")
      }
    },
    "ashley-dream": {
      title: t("case_study_detail.ashley.title"),
      year: t("case_study_detail.ashley.year"),
      location: t("case_study_detail.ashley.location"),
      clientType: t("case_study_detail.ashley.client_type"),
      challenge: t("case_study_detail.ashley.challenge"),
      solution: t("case_study_detail.ashley.solution"),
      image: "/images/about/Ashley.png",
      solutionItems: [
        t("case_study_detail.ashley.solution_items.0"),
        t("case_study_detail.ashley.solution_items.1"),
        t("case_study_detail.ashley.solution_items.2"),
        t("case_study_detail.ashley.solution_items.3")
      ],
      outcomes: [
        t("case_study_detail.ashley.outcomes.0"),
        t("case_study_detail.ashley.outcomes.1"),
        t("case_study_detail.ashley.outcomes.2")
      ]
    }
  };

  const caseStudy = caseStudies[id] || caseStudies["adelaide-tech"];

  return (
    <>
      <SEO title={`${caseStudy.title} - Cyberate Investments`} />
      <main className="page-wrapper">
        <HeaderOne btnStyle="round" HeaderSTyle="header-not-transparent" />

        <div className="container page-content-text" style={{ paddingTop: 160, paddingBottom: 100 }}>
          {/* 大图片 */}
          <div className="case-study-hero" style={{ 
            height: '400px', 
            borderRadius: '12px', 
            marginBottom: '40px',
            overflow: 'hidden'
          }}>
            <img 
              src={caseStudy.image} 
              alt={caseStudy.title}
              className="img-fluid"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </div>

          {/* 案例研究详情卡片 */}
          <div className="cy-panel cy-panel--p40" style={{ marginBottom: 28 }}>
            <h2 style={{ color: '#fff', fontWeight: 700, textAlign: 'center', marginBottom: 30 }}>
              {caseStudy.title}
            </h2>
            
            {/* 基本信息 */}
            <div className="case-study-info" style={{ marginBottom: 40 }}>
              <div className="row">
                <div className="col-md-4">
                  <div style={{ color: '#fff', marginBottom: 15 }}>
                    <strong style={{ background: 'linear-gradient(90deg, #FFAE2C 0%, #FFD945 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{t("case_study_detail.labels.year")}</strong> {caseStudy.year}
                  </div>
                </div>
                <div className="col-md-4">
                  <div style={{ color: '#fff', marginBottom: 15 }}>
                    <strong style={{ background: 'linear-gradient(90deg, #FFAE2C 0%, #FFD945 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{t("case_study_detail.labels.location")}</strong> {caseStudy.location}
                  </div>
                </div>
                <div className="col-md-4">
                  <div style={{ color: '#fff', marginBottom: 15 }}>
                    <strong style={{ background: 'linear-gradient(90deg, #FFAE2C 0%, #FFD945 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{t("case_study_detail.labels.client_type")}</strong> {caseStudy.clientType}
                  </div>
                </div>
              </div>
            </div>

            {/* Challenge */}
            <div className="case-study-section" style={{ marginBottom: 30 }}>
              <h3 style={{ color: '#fff', fontWeight: 600, marginBottom: 15 }}>{t("case_study_detail.labels.challenge")}</h3>
              <p style={{ color: '#ccc', fontSize: '16px', lineHeight: '1.6' }}>
                {caseStudy.challenge}
              </p>
            </div>

            {/* Solution */}
            <div className="case-study-section" style={{ marginBottom: 30 }}>
              <h3 style={{ color: '#fff', fontWeight: 600, marginBottom: 15 }}>{t("case_study_detail.labels.solution")}</h3>
              <p style={{ color: '#ccc', fontSize: '16px', lineHeight: '1.6', marginBottom: 15 }}>
                {caseStudy.solution}
              </p>
              {caseStudy.solutionItems && (
                <ul style={{ color: '#ccc', fontSize: '16px', lineHeight: '1.6', paddingLeft: '20px', listStyleType: 'none' }}>
                  {caseStudy.solutionItems.map((item, index) => (
                    <li key={index} style={{ marginBottom: '8px' }}>● {item}</li>
                  ))}
                </ul>
              )}
            </div>

            {/* Outcome */}
            <div className="case-study-section" style={{ marginBottom: 30 }}>
              <h3 style={{ color: '#fff', fontWeight: 600, marginBottom: 15 }}>{t("case_study_detail.labels.outcome")}</h3>
              <ul style={{ color: '#ccc', fontSize: '16px', lineHeight: '1.6', paddingLeft: '20px', listStyleType: 'none' }}>
                {caseStudy.outcomes.map((outcome, index) => (
                  <li key={index} style={{ marginBottom: '8px' }}>● {outcome}</li>
                ))}
              </ul>
            </div>

            {/* Testimonial */}
            {caseStudy.testimonial && (
              <div className="case-study-testimonial" style={{ 
                background: 'rgba(255, 255, 255, 0.05)', 
                borderRadius: '12px', 
                padding: '30px',
                marginTop: '40px',
                border: '1px solid rgba(255, 200, 47, 0.3)'
              }}>
                <blockquote style={{ 
                  color: '#fff', 
                  fontSize: '18px', 
                  lineHeight: '1.6', 
                  fontStyle: 'italic',
                  marginBottom: '20px',
                  borderLeft: '4px solid rgba(255, 200, 47, 1)',
                  paddingLeft: '20px'
                }}>
                  "{caseStudy.testimonial.quote}"
                </blockquote>
                <cite style={{ 
                  background: 'linear-gradient(90deg, #FFAE2C 0%, #FFD945 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  fontSize: '16px', 
                  fontWeight: '600',
                  fontStyle: 'normal'
                }}>
                  — {caseStudy.testimonial.author}
                </cite>
              </div>
            )}
          </div>
        </div>

        <FooterTwo />
      </main>
    </>
  );
};

export default CaseStudyDetail;
